// ─────────────────────────────────────────────────────────────────────
// HOW LONG THE SERVER SAID TO WAIT (#778 Q7).
//
// Every throttled door answers `429 {"error":"too_many_attempts"}` with
// `Retry-After` in whole seconds (`apps/api/src/auth/throttleRefusal.ts`). This
// is the one reader of that header in the web app; three clients each had their
// own, with three different answers for a missing one (0, 0 and 60).
//
// ── READABLE ONLY BECAUSE THE API EXPOSES IT ──────────────────────
//
// The API is on another origin (dev.spoint.no → api-dev.spoint.no), and a
// browser hands script only the CORS-safelisted response headers unless the
// server lists more in `Access-Control-Expose-Headers`. Until #778 it did not,
// so this read null on every deployed throttle. `cors-contract.test.ts`
// derives the exposed list from the headers the web reads, this one included.
//
// ── ZERO MEANS «WE DO NOT KNOW» ───────────────────────────────────
//
// Not 60, not one minute: an invented number shown to a person as a fact is
// worse than «try again shortly», which is what the screens say for zero. Only
// delta-seconds are read; the API never sends an HTTP date, and parsing one
// would mean trusting this device's clock against the server's.
// ─────────────────────────────────────────────────────────────────────

/** Whole seconds from `Retry-After`, or 0 when absent, unreadable or not delta-seconds. */
export function retryAfterSeconds(res: { headers: { get(name: string): string | null } }): number {
  const raw = (res.headers.get('Retry-After') ?? '').trim();
  if (!/^\d+$/.test(raw)) return 0;
  const seconds = Number(raw);
  return Number.isSafeInteger(seconds) ? seconds : 0;
}
